/**
 * Pulsanti toolbar form incidente (Add Vehicle / Add Person come riferimento): 88×40, angoli 8px (MUI borderRadius 2).
 * @param {import('@mui/material').Theme} theme
 * @param {'add' | 'delete' | 'photo'} variant — photo = cyan come add, con gap per icona + badge testo
 */
export function formToolbarActionButtonSx(theme, variant) {
  const base = {
    minWidth: 88,
    width: 88,
    minHeight: 40,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  }
  if (variant === 'delete') {
    return {
      ...base,
      background: theme.palette.newColors.pinkGradient,
    }
  }
  const cyan = {
    ...base,
    background: theme.palette.newColors.cyanGradient,
  }
  if (variant === 'photo') {
    return {
      ...cyan,
      gap: 0.5,
    }
  }
  return cyan
}
